import JSZip from 'jszip';

function downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    try {
        document.body.appendChild(link);
        link.click();
    } finally {
        link.remove();
        // Allow the browser to start the download before releasing the URL.
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
}

/** Função utilizada para baixar arquivos csv / xml */
export async function downloadTextFile(value: string | string[], fileName: string): Promise<void> {
    const source = typeof value === 'string' ? value : value.join('\n');

    const blob = new Blob(
        [
            new Uint8Array([0xef, 0xbb, 0xbf]), // UTF-8 BOM
            source,
        ],
        { type: 'text/plain;charset=utf-8' },
    );

    downloadBlob(blob, fileName);
}

export async function downloadFile(url: string, filename: string): Promise<void> {
    const response = await fetch(url);
    const blob = await response.blob();
    downloadBlob(blob, filename);
}

/** Baixa os arquivos enviados no array como um arquivo .zip */
export async function downloadFilesAsZip(urls: string[]): Promise<void> {
    const zip = new JSZip();
    const controller = new AbortController();
    const files: { name: string; blob: Blob }[] = [];
    let nextIndex = 0;

    const downloadNext = async (): Promise<void> => {
        if (controller.signal.aborted) {
            return;
        }

        const index = nextIndex++;
        const url = urls[index];
        if (url === undefined) {
            return;
        }

        try {
            const resp = await fetch(url, { signal: controller.signal });
            files[index] = {
                blob: await resp.blob(),
                name: url.substring(url.lastIndexOf('/') + 1),
            };
        } catch (error) {
            controller.abort(error);
            throw error;
        }

        await downloadNext();
    };

    // Bound independent downloads and observe every worker, including aborted requests.
    const results = await Promise.allSettled(
        Array.from({ length: Math.min(4, urls.length) }, () => downloadNext()),
    );

    const failure = results.find((result) => result.status === 'rejected');
    if (failure) {
        throw failure.reason;
    }

    // Preserve archive order and the original behavior when filenames repeat.
    for (const { name, blob } of files) {
        zip.file(name, blob);
    }

    const blob = await zip.generateAsync({ type: 'blob' });
    downloadBlob(blob, 'xmls.zip');
}
